import React from 'react';
import DataStore from '../flux/stores/DataStore.js';
import Layout from './layout.js';
import NewsGrid from './news-grid.js';
import Footer from './footer.js';
import {Helmet} from 'react-helmet';

class News extends React.Component {
  render() {
    const news = DataStore.getPageBySlug('news'); // only used for SEO

    return (
      <div>
        <Helmet>
          <title>Mold Architects - News</title>
          <meta name="description" content={news.yoast.metadesc} />
          <meta name="keywords" content={news.yoast.metakeywords} />

          <meta property="og:title" content={news.yoast['opengraph-title'] || 'Mold Architects - News'} />
          <meta name="og:description" content={news.yoast['opengraph-description'] || news.yoast.metadesc} />
          <meta property="og:image" content={news.yoast['opengraph-image']} />

          <meta name="twitter:title" content={news.yoast['twitter-title'] || 'Mold Architects - News'} />
          <meta name="twitter:description" content={news.yoast['twitter-description'] || news.yoast.metadesc} />
          <meta name="twitter:image" content={news.yoast['twitter-image'] || news.yoast['opengraph-image']} />
        </Helmet>
        <Layout>
          <NewsGrid />
        </Layout>
        <Footer footerClass="news" />
      </div>
    );
  }
}

export default News;



// WEBPACK FOOTER //
// ./src/scripts/components/news.js